/* eslint import/prefer-default-export: off */

enum personas {
  ALUMNI = 'umaAlumni',
  CURRENT_STUDENT = 'currentStudent',
  CAMPUS_CLEARWATER = 'umaClearwater',
  CAMPUS_ONLINE = 'umaOnline',
  CAREER_SERVICES = 'umaCareerServices',
  EMPLOYER = 'umaEmployer',
  INITIAL = 'umaOnline',
  PROGRAM_CLEARWATER = 'clearwaterProgram',
  PROGRAM_ONLINE = 'onlineProgram',
  WORK_HERE = 'umaWorkHere',
}

export { personas }
